//prettier-ignore
define('blockit',['require','exports','module','underscore','fukit','view/block/progress.modal.view','view/block/tabs.container.view'],function(require, exports, module) {
  var _     = require('underscore'),
      FuKit = require('fukit');

  // define local blocks here
  var localBlocks = {
    ProgressModalView: require('view/block/progress.modal.view'),
    TabsContainerView: require('view/block/tabs.container.view'),
  };

  var BlocKit = _.extend({}, FuKit.BlocKitShared, localBlocks)

  module.exports = BlocKit;
});

